import { ExtractionForm } from '../../../fragments/admin/price-extractions/ExtractionForm'

const CreateExtraction = () => {
    return (
        <main>
            <ExtractionForm />
        </main>
    )
}

export default CreateExtraction
